import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, Validators, AbstractControl, FormGroup, ReactiveFormsModule, ValidationErrors } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { EntityFormData } from '../../../../shared/models/entity-form-data';

@Component({
	selector: 'app-entity-form',
	standalone: true,
	imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatSlideToggleModule, MatButtonModule, MatIconModule, MatDialogTitle, MatDialogContent],
	templateUrl: './entity-form.html',
	styleUrl: './entity-form.css'
})

export class EntityForm {
	entityForm: FormGroup;
    isEditMode: boolean = false;
    private _entityIdToUpdate: string | null = null;

    constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<EntityForm, EntityFormData | undefined>, @Inject(MAT_DIALOG_DATA) public data: EntityFormData | null) {
        this.isEditMode = !!data;

        if(this.isEditMode) {
            this._entityIdToUpdate = data?.id || null;
        }

        this.entityForm = this.fb.group({
            name: [data?.name || '', [Validators.required]],
            entityEmail: [data?.entityEmail || '', [Validators.required]],
            legalRepresentative: [data?.legalRepresentative || '', [Validators.required]],
            legalRepresentativeEmail: [data?.legalRepresentativeEmail || '', [Validators.required, Validators.email]],
            status: [data?.status ?? true]
        });
    }

    get nameControl() {
        return this.entityForm.get('name');
    }

    get entityEmailControl() {
        return this.entityForm.get('entityEmail');
    }

    get legalRepresentativeControl() {
        return this.entityForm.get('legalRepresentative');
    }

    get legalRepresentativeEmailControl() {
        return this.entityForm.get('legalRepresentativeEmail');
    }

    onSubmit(): void {
        this.entityForm.markAllAsTouched();

        if(this.entityForm.valid) {
            const formData = this.entityForm.value;
            let   resultData: EntityFormData;

            if(this.isEditMode && this._entityIdToUpdate) {
                resultData = { ...formData, id: this._entityIdToUpdate } as EntityFormData;
            } else {
                resultData = formData as EntityFormData;
            }

            this.dialogRef.close(resultData);
        }
    }

    onCancel(): void {
        this.dialogRef.close(undefined);
    }
}
